export const Font = {
  fontSizeXl: "20px",
  fontSizeLg: "18px",
  fontSizeMd: "16px",
  fontSizeSm: "14px",
  fontSizeXs: "12px",

  fontFamilyDefault: `"Noto Sans CJK JP", "Helvetica Neue", arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", meiryo, sans-serif;`,
};
